module.exports = __webpack_public_path__ + "static/media/W18-0468_AW_250_Egger_desktop_hero_en.a18ccdbd.jpg";